<template>
  <div>
    <div style="margin-top: 1rem; display: flex;">
      <full-screen
        eid='main-dashboard'
      />
      <div style="padding-left: 1rem;">
        全螢幕
      </div>
    </div>

    <b-card id='main-dashboard' title="生產排程資訊">
      <!-- 錯誤訊息顯示區域 -->
      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>
      
      <!-- 表格組件 -->
      <SagTabletCalculate
        v-model="tableData"
        :loading="loading"
        :error="error"
        @date-change="handleDateChange"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SagTabletCalculate from '@/components/sag-kan-chart/SagTabletCalculate.vue'
import ApiKan from '@/components/sag-kan-chart/js/api'
import tools from '@/sag-core/tools'
import FullScreen from '@/components/basic/FullScreen.vue'

export default {
  name: 'KANMDTUI04',

  components: {
    BCard,
    SagTabletCalculate,
    FullScreen,
  },

  data() {
    return {
      tableData: [],
      error: null,
      loading: false,
      api: new ApiKan()
    }
  },

  created() {
    // 在組件創建時立即獲取數據
    this.fetchInitialData()
  },

  methods: {
    async fetchInitialData() {
      // 使用預設日期範圍獲取初始數據
      await this.handleDateChange({
        startDate: '2024-11-01',
        endDate: '2024-11-30'
      })
    },

    async handleDateChange(dateRange) {
      try {
        this.error = null
        this.loading = true

        tools.debug.log({
          tag: 'DEBUG',
          title: 'Fetching Data',
          content: dateRange
        })

        const response = await this.api.apiGetMFGTabletCalculate({
          StartDate: dateRange.startDate,
          EndDate: dateRange.endDate
        })
        
        tools.debug.log({
          tag: 'DEBUG',
          title: 'API Response',
          content: response
        })

        if (Array.isArray(response)) {
          // 直接使用 API 響應數據
          this.tableData = response
        } else {
          this.error = '數據格式不正確'
          tools.debug.log({
            tag: 'ERROR',
            title: 'Invalid Data Format',
            content: response
          })
        }
      } catch (error) {
        if (error.response) {
          this.error = `API錯誤: ${error.response.status} - ${error.response.statusText}`
        } else if (error.request) {
          this.error = '網路連接失敗或CORS錯誤'
        } else {
          this.error = error.message || '獲取資料失敗'
        }
        tools.debug.log({
          tag: 'ERROR',
          title: 'API Error',
          content: error
        })
        console.error('獲取資料失敗:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.alert {
  margin-bottom: 1rem;
}
</style>
